import { createRequest } from "helpers/tools";


export const editDestinationByConnectionId = async (connection_id, data) => {
    return await createRequest({
        suffix: `lead/connection/${connection_id}/destinations/edit`,
        handleError: true,
        method: "post",
        payload: {
            destination_id: data.destination_id,
            destination_type: data.destination_type,
        },
    });
};
